import { render } from "./mass-review-incentive.vue?vue&type=template&id=91b70484&ts=true"
import script from "./mass-review-incentive.ts?vue&type=script&lang=ts&external"
export * from "./mass-review-incentive.ts?vue&type=script&lang=ts&external"

import "./mass-review-incentive.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__